import React from 'react';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 } from 'uuid';
import { Container } from '../types/container';
import { ContainerContext, ContainerContextProps } from '../context/ContainerContext';

const containerState = {
  items: new Map<string, Container>(),
  loading: false,
};

export const containerSlice = createSlice({
  name: 'container',
  initialState: { key: v4() },
  reducers: {
    reset: state => {
      containerState.items = new Map();
      containerState.loading = true;
      state.key = v4();
    },
    set: (state, action: PayloadAction<Container[]>) => {
      containerState.items = new Map();
      action.payload.forEach(p => containerState.items.set(p.id, new Container(p)));
      state.key = v4();
    },
    add: (state, action: PayloadAction<Container[]>) => {
      action.payload.forEach(p => containerState.items.set(p.id, new Container(p)));
      containerState.items = new Map(containerState.items);
      state.key = v4();
    },
    delete: (state, action: PayloadAction<Container[]>) => {
      action.payload.forEach(p => containerState.items.delete(p.id));
      containerState.items = new Map(containerState.items);
      state.key = v4();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      containerState.loading = action.payload;
      state.key = v4();
    },
  },
});

interface ContainerProviderProps {
  children: React.ReactNode;
}

export default function ContainerProvider({ children }: ContainerProviderProps) {
  const dispatch = useAppDispatch();
  const key = useAppSelector(state => state.containers.key);

  const containerContext: ContainerContextProps = {
    containers: containerState.items,
    containersLoading: containerState.loading,
    setContainers: (containers: Map<string, Container>) => {
      dispatch(containerSlice.actions.set([...containers.values()]));
    },
  };

  return <ContainerContext.Provider value={containerContext}>{children}</ContainerContext.Provider>;
}
